const BREADCRUMB_NAVIGATION_LINK_TYPES = {
  HOME: 'HOME',
  COLLECTION: 'COLLECTION',
  PRODUCT: 'PRODUCT',
  GHOST: 'GHOST',
};

export { BREADCRUMB_NAVIGATION_LINK_TYPES };
